import { PerformanceGraph, FrequencyGraph, AccuracyGraph } from "./Charts";
import ActivityTimeline from "./ActivityTimeline";
import { Fragment, useEffect, useState } from "react";
import {
  getExerciseAccuracyGraph,
  getExercisePerformanceGraph,
  getFrequencyGraph,
  getProgramResults,
  getUserActivities,
} from "../../api/api";
import { Popover, Tab, Transition } from "@headlessui/react";
import {
  capitalize,
  WhiteLinearGradient,
  WhiteLinearGradientDarkPlain,
} from "../../utils/Utils";
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import ProgramResults from "./ProgramResults";
import Button from "../basic/Button";
import { useNavigate } from "react-router-dom";

function PerformancePage() {
  const [perfomanceData, setPerformanceData] = useState([]);
  const [frequencyData, setFrequencyData] = useState([]);
  const [accuracyData, setAccuracyData] = useState([]);
  const [userActivity, setUserActivity] = useState({});
  const [accuracyRange, setAccuracyRange] = useState("week");
  const navigate = useNavigate();

  async function updatePerformanceData() {
    let response = await getExercisePerformanceGraph();
    setPerformanceData(response);
  }

  async function updateAccuracyData() {
    let response = await getExerciseAccuracyGraph(accuracyRange);
    if (response) {
      let updatedResponse = [];
      response.forEach((data) => {
        if (data.accuracy == 0) {
          updatedResponse.push({
            accuracy: data.accuracy + 1,
            exercise: data.exercise,
          });
        } else {
          updatedResponse.push(data);
        }
      });
      setAccuracyData(updatedResponse);
    } else toast("Unable to fetch accuracy data", { type: "error" });
  }

  async function updateFrequencyData() {
    let response = await getFrequencyGraph();
    if (response) setFrequencyData(response);
    else toast("Unable to fetch frequency data", { type: "error" });
  }

  async function updateActivites() {
    let response = await getUserActivities();
    if (response) setUserActivity(response);
    else toast("Unable to fetch your activites", { type: "error" });
  }

  useEffect(() => {
    updatePerformanceData();
    updateAccuracyData();
    updateFrequencyData();
    updateActivites();
  }, []);

  useEffect(() => {
    updateAccuracyData();
  }, [accuracyRange]);

  console.log(frequencyData.length);

  return (
    <div
      className={`w-full h-full flex flex-1 py-5 md:py-10 px-5 md:px-28 ${WhiteLinearGradient}`}
    >
      <div className="w-full h-full  px-2 py-16 sm:px-0">
        <Tab.Group>
          <Tab.List className="flex space-x-10 h-16 w-full border-b-[1px] border-b-[#B6BCDA] dark:border-b-[#68696B80] overflow-auto">
            <Tab
              className={({ selected }) =>
                `${
                  selected
                    ? "border-b-4  text-primary-blue border-primary-blue dark:text-primary-neonGreen dark:border-primary-neonGreen   "
                    : "text-primary-lightBlue dark:text-primary-white"
                } h-full space-x-3 flex items-center justtify-center text-xl md:text-3xl font-medium `
              }
            >
              Activities
            </Tab>
            <Tab
              className={({ selected }) =>
                `${
                  selected
                    ? "border-b-4  text-primary-blue border-primary-blue dark:text-primary-neonGreen dark:border-primary-neonGreen   "
                    : "text-primary-lightBlue dark:text-primary-white"
                } h-full space-x-3 flex items-center justtify-center text-xl md:text-3xl font-medium `
              }
            >
              Progress
            </Tab>
            {/* <Tab
              className={({ selected }) =>
                `${
                  selected
                    ? "border-b-4  text-primary-blue border-primary-blue text-2xl md:text-4xl  "
                    : "text-primary-lightBlue text-lg"
                } h-full space-x-3 flex items-center justtify-center font-medium `
              }
            >
              Programs
            </Tab> */}
          </Tab.List>
          <Tab.Panels className="py-10 ">
            <Tab.Panel>
              <div className="px-4 md:px-28">
                <ActivityTimeline timeline={userActivity} />
              </div>
            </Tab.Panel>
            <Tab.Panel>
              <div className="flex flex-col  space-y-12 mt-5 md:px-28">
                <div
                  className={`col-span-1 h-full min-h-[350px] px-3 py-10 text-primary-black dark:text-primary-white border-[#B6BCDA80] dark:border-[#68696B33] border-[1px] ${WhiteLinearGradientDarkPlain} rounded-xl flex justify-center items-center`}
                >
                  {frequencyData.length == 0 ? (
                    <Button
                      type={"primary"}
                      onClick={() => {
                        navigate("/exercise");
                      }}
                    >
                      Do more exercises to get analytics
                    </Button>
                  ) : (
                    <FrequencyGraph
                      data={frequencyData}
                      xAxisKey="date"
                      yAxisKey="freuqency"
                    />
                  )}
                </div>
                <div
                  className={`flex flex-col col-span-1 h-full min-h-[350px] p-3 text-primary-black dark:text-primary-white border-[#B6BCDA80] dark:border-[#68696B33] border-[1px] ${WhiteLinearGradientDarkPlain} rounded-xl justify-end items-end`}
                >
                  <Popover className={"relative"}>
                    <Popover.Button
                      className={`flex flex-row space-x-2 ${WhiteLinearGradientDarkPlain} rounded-lg items-center p-2`}
                    >
                      <p className="font-bold">{capitalize(accuracyRange)}</p>
                      <Icon
                        icon={"akar-icons:chevron-down"}
                        className="text-primary-black dark:text-primary-white"
                      />
                    </Popover.Button>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-150"
                      enterFrom="opacity-0 translate-y-0"
                      enterTo="opacity-100 translate-y-1"
                      leave="transition ease-in duration-150"
                      leaveFrom="opacity-100 translate-y-1"
                      leaveTo="opacity-0 translate-y-0"
                    >
                      <Popover.Panel
                        className={`absolute z-10 w-20 -mt-1  p-4 space-y-2 flex flex-col ${WhiteLinearGradientDarkPlain} rounded-xl`}
                      >
                        {({ close }) => (
                          <>
                            <p
                              className="font-bold cursor-pointer"
                              onClick={() => {
                                setAccuracyRange("week");
                                close();
                              }}
                            >
                              Week
                            </p>
                            <p
                              className="font-bold cursor-pointer"
                              onClick={() => {
                                setAccuracyRange("month");
                                close();
                              }}
                            >
                              Month
                            </p>
                          </>
                        )}
                      </Popover.Panel>
                    </Transition>
                  </Popover>
                  {accuracyData.length == 0 ? (
                    <div className="h-full flex flex-1 w-full items-center justify-center ">
                      <Button
                        type={"primary"}
                        onClick={() => {
                          // navigate("/exercise");
                          navigate("/programpage");
                        }}
                        // className="h-12"
                      >
                        Do more exercises to get accuracy analysis for this{" "}
                        {accuracyRange}
                      </Button>
                    </div>
                  ) : (
                    <AccuracyGraph
                      data={accuracyData}
                      xAxisKey="exercise"
                      yAxisKey={"accuracy"}
                    />
                  )}
                </div>
                <div
                  className={`col-span-1 h-full min-h-[350px] px-3 py-10 text-primary-black  dark:text-primary-white border-[#B6BCDA80] dark:border-[#68696B33] border-[1px] ${WhiteLinearGradientDarkPlain} rounded-xl flex justify-center items-center`}
                >
                  {perfomanceData.length == 0 ? (
                    <Button
                      type={"primary"}
                      onClick={() => {
                        navigate("/exercise");
                      }}
                    >
                      Do more exercises to see your top performing exercise
                    </Button>
                  ) : (
                    <PerformanceGraph
                      data={perfomanceData}
                      xAxisKey="accuracy"
                      yAxisKey={"exercise"}
                    />
                  )}
                </div>
              </div>
            </Tab.Panel>
          </Tab.Panels>
        </Tab.Group>
      </div>
    </div>
  );
}

export default PerformancePage;

//                             ********** EXERCISE BAR-CHART  *********
//  <BarChart
//     width={800}
//     height={325}
//     data={frequencyData}
//     margin={{
//         top: 10,
//         right: 80,
//         left: 10,
//         bottom: 10
//     }}
//     padding={{
//         right: 10,
//         left: 10
//     }}
// >
//     <defs>
//         <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
//             <stop offset="5%" stopColor="#6C39D9" stopOpacity={0.9} />
//             <stop offset="95%" stopColor="6C39D9" stopOpacity={0.1} />
//         </linearGradient>
//     </defs>

//     <CartesianGrid horizontal={true} vertical={false} />
//     <XAxis
//         dataKey={frequencyData?.map((x) => (x.date))}
//         tickLine={{ stroke: false }}
//         tick={{ fill: 'white', fontSize: 12 }}
//     >
//         <Label value="Time" offset={0} position="insideBottom" color="white"
//             style={{ textAnchor: 'middle', fontSize: '14', fill: 'rgba(255,255,255, 0.9)', marginTop: '20%' }}
//         />
//     </XAxis>
//     <YAxis
//         tickLine={false}
//         axisLine={false}
//         tick={{ fill: 'white', fontSize: 12 }}
//     >
//         <Label value='Exercises' angle='-90' position='insideLeft'
//             style={{ textAnchor: 'middle', fontSize: '14', fill: 'rgba(255,255,255, 0.9)' }} />
//     </YAxis>
//     <Tooltip cursor={{ fill: '#0000' }} />
//     <Bar dataKey={frequencyData?.map((x) => x.freuqency)} barSize={45} fill="url(#colorUv)" radius={[50, 50, 0, 0]} >
//         {console.log(frequencyData?.map((x, key) => x.freuqency))}
//         <LabelList dataKey="pv" position="top" className="text-white text-sm font-bold"
//             style={{ textAnchor: 'middle', fontSize: '14', fill: 'rgba(255,255,255, 0.9)' }}
//         />
//     </Bar>
// </BarChart>

//                          ***********  CALORIES LINE-CHART  ***********
// <LineChart
//     width={800}
//     height={325}
//     margin={{
//         top: 10,
//         right: 80,
//         left: 10,
//         bottom: 10
//     }}
// >
//     <CartesianGrid horizontal={true} vertical={false} />
//     <XAxis
//         dataKey="category"
//         type="category"
//         allowDuplicatedCategory={false}
//         axisLine={true}
//         tick={{ fill: 'white', fontSize: 12 }}
//         tickLine={{ stroke: false }}
//     />
//     <YAxis
//         dataKey="value"
//         axisLine={false}
//         tick={{ fill: 'white', fontSize: 12 }}
//         tickLine={{ stroke: 'white' }}
//     />
//     <Tooltip />
//     {series.map((s) => (
//         <Line dataKey="value" data={s.data} name={s.name} key={s.name} stroke="#F05A3D" />
//     ))}
// </LineChart>
// <p className="flex justify-center lg:mb-6 mb-3 text-white lg:text-md text-sm">Times</p>

//                              ************  MINUTES LINE-CHART  ***********
//  <BarChart
//         width={800}
//         height={325}
//         data={data}
//         margin={{
//             top: 10,
//             right: 80,
//             left: 10,
//             bottom: 10
//         }}
//         padding={{
//             right: 10,
//             left: 10
//         }}
//     >
//         <defs>
//             <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
//                 <stop offset="5%" stopColor="#398CD9" stopOpacity={0.1} />
//                 <stop offset="95%" stopColor="#3A8CD8" stopOpacity={1} />
//             </linearGradient>
//         </defs>
//         <CartesianGrid horizontal={true} vertical={false} />
//         <XAxis
//             dataKey="name"
//             tickLine={{ stroke: false }}
//             tick={{ fill: 'white', fontSize: 12 }}
//         >
//             <Label value="Time" offset={0} position="insideBottom" color="white"
//                 style={{ textAnchor: 'middle', fontSize: '14', fill: 'rgba(255,255,255, 0.9)', marginTop: '20%' }}
//             />
//         </XAxis>
//         <YAxis
//             tickLine={false}
//             axisLine={false}
//             tick={{ fill: 'white', fontSize: 12 }}
//         >
//             <Label value='Exercises' angle='-90' position='insideLeft'
//                 style={{ textAnchor: 'middle', fontSize: '14', fill: 'rgba(255,255,255, 0.9)' }} />
//         </YAxis>
//         <Tooltip cursor={{ fill: '#0000' }} />
//         <Bar dataKey="pv" barSize={45} fill="url(#colorUv)" radius={[50, 50, 0, 0]}>
//             <LabelList dataKey="pv" position="top" className="text-white text-sm font-bold"
//                 style={{ textAnchor: 'middle', fontSize: '14', fill: 'rgba(255,255,255, 0.9)' }}
//             />
//         </Bar>
//     </BarChart>

// OLD CODE
// import { PerformanceGraph, FrequencyGraph, AccuracyGraph } from "./Charts";
// import ActivityTimeline from "./ActivityTimeline";
// import { Fragment, useEffect, useState } from "react";
// import {
//   getExerciseAccuracyGraph,
//   getExercisePerformanceGraph,
//   getFrequencyGraph,
//   getProgramResults,
//   getUserActivities,
// } from "../../api/api";
// import { Popover, Tab, Transition } from "@headlessui/react";
// import {
//   capitalize,
//   WhiteLinearGradient,
//   WhiteLinearGradientDarkPlain,
// } from "../../utils/Utils";
// import { Icon } from "@iconify/react";
// import { toast } from "react-toastify";
// import ProgramResults from "./ProgramResults";
// import Button from "../basic/Button";
// import { useNavigate } from "react-router-dom";

// function PerformancePage() {
//   const [perfomanceData, setPerformanceData] = useState([]);
//   const [frequencyData, setFrequencyData] = useState([]);
//   const [accuracyData, setAccuracyData] = useState([]);
//   const [userActivity, setUserActivity] = useState({});
//   const [accuracyRange, setAccuracyRange] = useState("week");
//   const navigate = useNavigate();

//   async function updatePerformanceData() {
//     let response = await getExercisePerformanceGraph();
//     console.log(response);
//     setPerformanceData(response);
//   }

//   async function updateAccuracyData() {
//     let response = await getExerciseAccuracyGraph(accuracyRange);
//     if (response) {
//       let updatedResponse = [];
//       response.forEach((data) => {
//         if (data.accuracy == 0) {
//           updatedResponse.push({
//             accuracy: data.accuracy + 1,
//             exercise: data.exercise,
//           });
//         } else {
//           updatedResponse.push(data);
//         }
//       });
//       console.log({ response });
//       console.log({ updatedResponse });
//       setAccuracyData(updatedResponse);
//     } else toast("Unable to fetch accuracy data", { type: "error" });
//   }

//   async function updateFrequencyData() {
//     let response = await getFrequencyGraph();
//     if (response) setFrequencyData(response);
//     else toast("Unable to fetch frequency data", { type: "error" });
//   }

//   async function updateActivites() {
//     let response = await getUserActivities();
//     if (response) setUserActivity(response);
//     else toast("Unable to fetch your activites", { type: "error" });
//   }

//   useEffect(() => {
//     updatePerformanceData();
//     updateAccuracyData();
//     updateFrequencyData();
//     updateActivites();
//   }, []);

//   useEffect(() => {
//     updateAccuracyData();
//   }, [accuracyRange]);

//   return (
//     <div
//       className={`w-full h-full flex flex-1 py-5 md:py-10 px-5 md:px-28 ${WhiteLinearGradient}`}
//     >
//       <div className="w-full h-full  px-2 py-16 sm:px-0">
//         <Tab.Group>
//           <Tab.List className="flex space-x-10 h-16 w-full border-b-[1px] border-b-[#B6BCDA] dark:border-b-[#68696B80] overflow-auto">
//             <Tab
//               className={({ selected }) =>
//                 `${
//                   selected
//                     ? "border-b-4  text-primary-blue border-primary-blue dark:text-primary-neonGreen dark:border-primary-neonGreen   "
//                     : "text-primary-lightBlue dark:text-primary-white"
//                 } h-full space-x-3 flex items-center justtify-center text-xl md:text-3xl font-medium `
//               }
//             >
//               Progress
//             </Tab>
//             <Tab
//               className={({ selected }) =>
//                 `${
//                   selected
//                     ? "border-b-4  text-primary-blue border-primary-blue dark:text-primary-neonGreen dark:border-primary-neonGreen   "
//                     : "text-primary-lightBlue dark:text-primary-white"
//                 } h-full space-x-3 flex items-center justtify-center text-xl md:text-3xl font-medium `
//               }
//             >
//               Activities
//             </Tab>
//             {/* <Tab
//               className={({ selected }) =>
//                 `${
//                   selected
//                     ? "border-b-4  text-primary-blue border-primary-blue text-2xl md:text-4xl  "
//                     : "text-primary-lightBlue text-lg"
//                 } h-full space-x-3 flex items-center justtify-center font-medium `
//               }
//             >
//               Programs
//             </Tab> */}
//           </Tab.List>
//           <Tab.Panels className="py-10 ">
//             <Tab.Panel>
//               <div className="flex flex-col  space-y-12 mt-5 md:px-28">
//                 <div
//                   className={`col-span-1 h-full min-h-[350px] px-3 py-10 text-primary-black dark:text-primary-white border-[#B6BCDA80] dark:border-[#68696B33] border-[1px] ${WhiteLinearGradientDarkPlain} rounded-xl flex justify-center items-center`}
//                 >
//                   {frequencyData.length == 0 ? (
//                     <Button
//                       type={"primary"}
//                       onClick={() => {
//                         navigate("/exercise");
//                       }}
//                     >
//                       Do more exercises to get analytics
//                     </Button>
//                   ) : (
//                     <FrequencyGraph
//                       data={frequencyData}
//                       xAxisKey="date"
//                       yAxisKey="freuqency"
//                     />
//                   )}
//                 </div>
//                 <div
//                   className={`flex flex-col col-span-1 h-full min-h-[350px] p-3 text-primary-black dark:text-primary-white border-[#B6BCDA80] dark:border-[#68696B33] border-[1px] ${WhiteLinearGradientDarkPlain} rounded-xl justify-end items-end`}
//                 >
//                   <Popover className={"relative"}>
//                     <Popover.Button
//                       className={`flex flex-row space-x-2 ${WhiteLinearGradientDarkPlain} rounded-lg items-center p-2`}
//                     >
//                       <p className="font-bold">{capitalize(accuracyRange)}</p>
//                       <Icon
//                         icon={"akar-icons:chevron-down"}
//                         className="text-primary-black dark:text-primary-white"
//                       />
//                     </Popover.Button>
//                     <Transition
//                       as={Fragment}
//                       enter="transition ease-out duration-150"
//                       enterFrom="opacity-0 translate-y-0"
//                       enterTo="opacity-100 translate-y-1"
//                       leave="transition ease-in duration-150"
//                       leaveFrom="opacity-100 translate-y-1"
//                       leaveTo="opacity-0 translate-y-0"
//                     >
//                       <Popover.Panel
//                         className={`absolute z-10 w-20 -mt-1  p-4 space-y-2 flex flex-col ${WhiteLinearGradientDarkPlain} rounded-xl`}
//                       >
//                         {({ close }) => (
//                           <>
//                             <p
//                               className="font-bold cursor-pointer"
//                               onClick={() => {
//                                 setAccuracyRange("week");
//                                 close();
//                               }}
//                             >
//                               Week
//                             </p>
//                             <p
//                               className="font-bold cursor-pointer"
//                               onClick={() => {
//                                 setAccuracyRange("month");
//                                 close();
//                               }}
//                             >
//                               Month
//                             </p>
//                           </>
//                         )}
//                       </Popover.Panel>
//                     </Transition>
//                   </Popover>
//                   {accuracyData.length == 0 ? (
//                     <div className="h-full flex flex-1 w-full items-center justify-center ">
//                       <Button
//                         type={"primary"}
//                         onClick={() => {
//                           navigate("/exercise");
//                         }}
//                         // className="h-12"
//                       >
//                         Do more exercises to get accuracy analysis for this{" "}
//                         {accuracyRange}
//                       </Button>
//                     </div>
//                   ) : (
//                     <AccuracyGraph
//                       data={accuracyData}
//                       xAxisKey="exercise"
//                       yAxisKey={"accuracy"}
//                     />
//                   )}
//                 </div>
//                 <div
//                   className={`col-span-1 h-full min-h-[350px] px-3 py-10 text-primary-black  dark:text-primary-white border-[#B6BCDA80] dark:border-[#68696B33] border-[1px] ${WhiteLinearGradientDarkPlain} rounded-xl flex justify-center items-center`}
//                 >
//                   {perfomanceData.length == 0 ? (
//                     <Button
//                       type={"primary"}
//                       onClick={() => {
//                         navigate("/exercise");
//                       }}
//                     >
//                       Do more exercises to see your top performing exercise
//                     </Button>
//                   ) : (
//                     <PerformanceGraph
//                       data={perfomanceData}
//                       xAxisKey="accuracy"
//                       yAxisKey={"exercise"}
//                     />
//                   )}
//                 </div>
//               </div>
//             </Tab.Panel>
//             <Tab.Panel>
//               <div className="px-4 md:px-28">
//                 <ActivityTimeline timeline={userActivity} />
//               </div>
//             </Tab.Panel>
//             {/* <Tab.Panel>
//               <ProgramResults programResults={programResults} />
//             </Tab.Panel> */}
//           </Tab.Panels>
//         </Tab.Group>
//       </div>
//     </div>
//   );
// }

// export default PerformancePage;
